import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { LoadingController } from '@ionic/angular';
import { ProjectService } from './project.service';
import { HttpClient } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
import { Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { ChangeDetectorRef } from '@angular/core';
import write_blob from 'capacitor-blob-writer';
import { Observable as RxObservable, tap, map, firstValueFrom } from 'rxjs';

import * as $ from 'jquery';
import * as moment from 'moment';

import { set, get, remove } from './services/storage';

@Injectable({
  providedIn: 'root',
})
export class SavestateService {
  public sketchFiles = [];
  public previewFiles = [];
  public photoFiles = [];
  public buildingPhotoFiles = [];
  public ifcFiles = [];
  public xktFiles = [];
  public recordingFiles = [];
  public modelViewFiles: ModelViewQueueEntry[] = [];

  private SKETCHES_STORAGE: string = 'stored_sketches';
  private PREVIEWS_STORAGE: string = 'stored_previews';
  private PHOTOS_STORAGE: string = 'stored_photos';
  private BUILDINGS_PHOTOS_STORAGE: string = 'stored_building_photos';
  private RECORDINGS_STORAGE: string = 'stored_recordings';
  private MODELVIEWS_STORAGE: string = 'stored_model_views';
  private IFCFILES_STORAGE: string = 'stored_ifcfiles';
  private XKTFILES_STORAGE: string = 'stored_xktfiles';
  private PREFERENCES_STORAGE: string = 'stored_preferences';

  public user: any;
  public user_id?: number;
  private loading: any;
  public loader: any;
  public error: string;
  public is_web: any;
  public session_key: string;
  public sketch_counter = 0;
  public ifc_counter = 0;
  public xkt_counter = 0;
  public preview_counter = 0;
  public photo_counter = 0;
  public buildings_photo_counter = 0;
  public recordings_counter = 0;
  public timestamp: any;
  public custompintypes: any;
  public projects: any;
  public buildings: any;
  public building_temperature: any;
  public damages: any;
  public custompins: any;
  public actual_pin_id?: number;
  public client: any;
  public notes: any;
  public sketches = [];
  public ifcs = [];
  public xkts = [];
  public previews = [];
  public photos = [];
  public building_photos = [];
  public recordings = [];
  public examples: any;
  public componentgroups: any;
  public damagetypes: any;
  private baseDir = Directory.Data;
  public user_data: any;
  public damagetemplates = [];

  public show_photos_offline = false;
  private cache_big_image: any;
  public bu_del_photos_not_synced?: any;
  public bu_photo_notes_not_synced?: any;

  sketchesLength = 0;
  sketchesProgress = 0;
  ifcLength = 0;
  ifcProgress = 0;
  xktLength = 0;
  xktProgress = 0;
  photosLength = 0;
  buildingPhotosLength = 0;
  recordingsLength = 0;
  photosProgress = 0;
  recordingsProgress = 0;

  constructor(
    private sanitizer: DomSanitizer,
    public api: ProjectService,
    public loadingController: LoadingController,
    private readonly http: HttpClient,
    public toastController: ToastController,
    public platform: Platform
  ) {
    if (Capacitor.getPlatform() === 'web') {
      this.is_web = true;
    } else {
      this.is_web = false;
    }

    if (Capacitor.getPlatform() === 'ios') {
      this.baseDir = Directory.Documents;
    }

    Network.addListener('networkStatusChange', (status) => {
      console.log('****Network status changed****', status);
      if (!status.connected) {
        this.presentToast(
          'Sie haben keine Internetverbindung mehr - es werden ausschließlich heruntergeladene Bilder angezeigt.'
        );
      }
    });
  }

  public async listFiles(): Promise<
    { name: string; size: number; type: string }[]
  > {
    const result = await Filesystem.readdir({
      path: '',
      directory: this.baseDir,
    });

    let files = await Promise.all(
      result.files.map(async (fileInfo) => {
        const filePath = `${this.baseDir}/${fileInfo.name}`;
        const fileStat = await Filesystem.stat({
          path: fileInfo.name,
          directory: this.baseDir,
        });

        const sizeInMB = fileStat.size / (1024 * 1024);
        const fileType = fileInfo.name.split('.').pop() || 'unknown';

        return {
          name: fileInfo.name,
          type: fileType,
          size: sizeInMB,
        };
      })
    );

    files = files.sort((a, b) => {
      if (a.type === b.type) {
        return a.name.localeCompare(b.name);
      }
      return a.type.localeCompare(b.type);
    });

    return files;
  }

  public async checkNetworkStatus() {
    const status = await Network.getStatus();
    return status;
  }

  public getImgContent(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public germanDate(date) {
    let date_ger = moment(date).format('DD.MM.y');
    return date_ger;
  }

  public germanDateTime(date) {
    let date_ger = moment(date).format('DD.MM.y HH:mm');
    return date_ger;
  }

  async getFileUriPlain(filename) {
    let directory = Directory.Data;

    if (this.platform.is('ios')) {
      directory = Directory.Documents;
    }

    try {
      const fileInfo = await Filesystem.stat({
        directory: directory,
        path: filename,
      });
      console.log('!!File exists', fileInfo);
    } catch (error) {
      console.error('!!File does not exist', error);
    }

    const file_uri = await Filesystem.getUri({
      directory: directory,
      path: filename,
    });

    let image_url = Capacitor.convertFileSrc(file_uri.uri);
    console.log('ImgUrl: ', JSON.stringify(image_url));
    return image_url;
  }

  async getFileUri(filename) {
    let directory = Directory.Data;

    if (this.platform.is('ios')) {
      directory = Directory.Documents;
    }

    try {
      const fileInfo = await Filesystem.stat({
        directory: directory,
        path: filename,
      });
      console.log('!!File exists', fileInfo);
    } catch (error) {
      console.error('!!File does not exist', error);
    }

    const file_uri = await Filesystem.getUri({
      directory: directory,
      path: filename,
    });
    let image_url = Capacitor.convertFileSrc(file_uri.uri);
    let path = this.getImgContent(image_url);
    console.log('ImgUrl: ', JSON.stringify(path));
    return path;
  }

  async getImagePath(full_path) {
    if (!full_path) {
      return null;
    }
    let filename = full_path.replace(/^.*[\\\/]/, '');
    const exists = await this.checkFileExists(filename);
    if (!exists) {
      return null;
    }
    let path = await this.getCapacitorUri(filename);
    return path;
  }

  getPinPhoto(pin, network_status) {
    let has_new_photos = false;
    let has_photos = false;
    let has_stored_photos = false;

    if (pin.new_photos) {
      if (!Array.isArray(pin.new_photos)) {
        pin.new_photos = JSON.parse(pin.new_photos);
      }
      if (pin.new_photos.length) {
        has_new_photos = true;
      }
    }
    if (pin.photos) {
      if (pin.photos.length) {
        has_photos = true;
      }
    }
    if (this.photoFiles) {
      if (this.photoFiles.length) {
        has_stored_photos = true;
      }
    }

    console.log('States:', has_new_photos, has_photos, has_stored_photos);
    console.log('Pin: ', pin);
    if (has_new_photos) {
      let new_photos: any;
      try {
        new_photos = JSON.parse(pin.new_photos);
      } catch (error) {
        new_photos = pin.new_photos;
      }

      let new_photo = new_photos.at(-1);
      if (new_photo) {
        console.log('Path:', new_photo.path);
        return new_photo.path;
      }
    } else {
      if (has_photos) {
        console.log('photo object', pin.photos.at(-1));
        let photo = pin.photos.at(-1);
        console.log('network', network_status);
        if (!network_status && has_stored_photos) {
          for (let i = 0; i < this.photoFiles.length; i++) {
            //console.log(this.photoFiles[i].id, photo.id);
            console.log(
              'photo keys:',
              JSON.stringify(Object.keys(pin.photos.at(-1) ?? {}))
            );
            console.log(
              'photo.id value/type:',
              JSON.stringify(pin.photos.at(-1)?.id),
              JSON.stringify(typeof pin.photos.at(-1)?.id)
            );

            if (this.photoFiles[i].id == photo.id) {
              console.log('Found!');
              return this.photoFiles[i].webviewPath;
            }
          }
        }
        if (has_photos && network_status) {
          return photo.image_path;
        }
      }
    }
    return undefined;
  }

  async getCapacitorUri(filename) {
    let directory = Directory.Data;

    if (this.platform.is('ios')) {
      directory = Directory.Documents;
    }
    const file_uri = await Filesystem.getUri({
      directory: directory,
      path: filename,
    });
    let path = Capacitor.convertFileSrc(file_uri.uri);
    console.log('Path: ', path);
    return path;
  }

  async checkFileExists(path): Promise<boolean> {
    let directory = Directory.Data;

    if (this.platform.is('ios')) {
      directory = Directory.Documents;
    }

    try {
      await Filesystem.stat({
        path: path,
        directory: directory,
      });
      return true;
    } catch (checkDirException) {
      if (checkDirException.message === 'File does not exist') {
        return false;
      } else {
        throw checkDirException;
      }
    }
  }

  public async reloadData() {
    this.ifc_counter = 0;
    this.xkt_counter = 0;
    this.photo_counter = 0;
    this.buildings_photo_counter = 0;
    this.sketch_counter = 0;
    this.recordings_counter = 0;
    console.log('SS ReloadData:');
    // Session Key
    let session_key = await get('session_key');
    if (session_key) {
      (window as any).session_key = session_key;
      this.session_key = session_key;
      console.log('Session Key', session_key);

      this.getUser();

      // Timestamp of last sync
      let timestamp = await get('last_sync');
      (window as any).timestamp = timestamp;
      this.timestamp = timestamp;
      console.log('Timestamp', timestamp);

      // Relevant Data
      let custompintypes = await get('custompintypes');
      this.custompintypes = custompintypes;
      console.log('custompintypes', custompintypes);

      let projects = await get('projects');
      this.projects = projects;
      console.log('Projects', projects);

      let buildings = await get('buildings');
      this.buildings = buildings;
      console.log('Buildings', buildings);

      let damages = await get('damages');
      this.damages = damages;
      console.log('damages', damages);

      let user = await get('user');
      this.user = user;
      console.log('user', user);

      let user_id = await get('user_id');
      this.user_id = user_id;
      console.log('user_id', user_id);

      let custompins = await get('custompins');
      this.custompins = custompins;
      if (
        this.custompins == null ||
        typeof this.custompins == 'undefined' ||
        this.custompins == 'undefined' ||
        this.custompins == undefined
      ) {
        this.custompins = {};
      }
      if (Array.isArray(this.custompins) && this.custompins.length === 0) {
        this.custompins = {};
        custompins = {};
      }
      console.log('custompins', this.custompins);

      let notes = await get('notes');
      this.notes = notes;
      console.log('notes', notes);

      let sketches = await get('sketches');
      this.sketches = sketches || [];
      console.log('sketches', sketches);

      let ifcs = await get('ifcs');
      this.ifcs = ifcs || [];
      console.log('SS Reload ifcs', ifcs);

      let xkts = await get('xkts');
      this.xkts = xkts || [];
      console.log('SS Reload xkts', xkts);

      let client = await get('client');
      this.client = client;
      console.log('client', client);

      let sketchFiles = await get('stored_sketches');
      this.sketchFiles = sketchFiles;
      if (!this.sketchFiles) {
        this.sketchFiles = [];
      }
      console.log('stored_sketches', sketchFiles);

      let ifcFiles = await get('stored_ifcfiles');
      this.ifcFiles = ifcFiles;
      if (!this.ifcFiles) {
        this.ifcFiles = [];
      }
      console.log('stored_ifcfiles', ifcFiles);

      let xktFiles = await get('stored_xktfiles');
      this.xktFiles = xktFiles;
      if (!this.xktFiles) {
        this.xktFiles = [];
      }
      console.log('stored_xktfiles', xktFiles);

      /* this.updateProgress(); */

      let previewFiles = await get('stored_previews');
      this.previewFiles = previewFiles;
      if (!this.previewFiles) {
        this.previewFiles = [];
      }
      console.log('stored_previews', previewFiles);

      let photoFiles = await get('stored_photos');
      this.photoFiles = photoFiles;
      if (!this.photoFiles) {
        this.photoFiles = [];
      }
      console.log('stored_photos', photoFiles);

      let recordingFiles = await get('stored_recordings');
      this.recordingFiles = recordingFiles;
      if (!this.recordingFiles) {
        this.recordingFiles = [];
      }
      console.log('stored_photos', photoFiles);

      let buildingPhotoFiles = await get('stored_building_photos');
      this.buildingPhotoFiles = buildingPhotoFiles;
      if (!this.buildingPhotoFiles) {
        this.buildingPhotoFiles = [];
      }

      let modelViewFiles = await get(this.MODELVIEWS_STORAGE);
      this.modelViewFiles = Array.isArray(modelViewFiles) ? modelViewFiles : [];
      console.log('stored_model_views', this.modelViewFiles.length);

      let previews = await get('previews');
      this.previews = previews;
      console.log('previews', previews);

      this.updateProgress();
      // Existiert nicht im Local Storage...
      /*       let photos = await get('stored_photos');
      this.photos = photos;
      console.log('photos', photos); */

      let componentgroups = await get('componentgroups');
      this.componentgroups = componentgroups;
      console.log('componentgroups', componentgroups);

      let damagetypes = await get('damagetypes');
      this.damagetypes = damagetypes;
      console.log('damagetypes', damagetypes);

      let examples = await get('examples');
      this.examples = examples;
      console.log('examples', examples);

      let damagetemplates = await get('damagetemplates');
      this.damagetemplates = damagetemplates;
      console.log('damagetemplates', damagetemplates);

      let preferences = await get(this.PREFERENCES_STORAGE);
      if (preferences) {
        this.show_photos_offline = preferences.show_photos_offline;
      }
      console.log('preferences', preferences);
    } else {
      // No Session Key has been found => Redirect to login and do nothing
      // alert("No Session Key - Back to Login!!");
    }
  }

  public getDistance(x1, x2, y1, y2) {
    console.log('Calculating Distance!');
    let y = x2 - x1;
    let x = y2 - y1;
    console.log('Distance: ', Math.sqrt(x * x + y * y));
    return Math.sqrt(x * x + y * y);
  }

  public check(): any {
    get('projects').then((val) => {
      if (val) {
        return true;
      } else {
        return false;
      }
    });
  }

  public getUser(): any {
    let self = this;
    get('user').then((val) => {
      self.user = val;
    });

    get('user_id').then((val) => {
      self.user_id = val;
    });
    console.log('UserID:', this.user_id);
  }

  public save() {
    // Write Global Objects as JSON to localstorage
    console.log('Lokaler Speicher wird überschrieben');

    set('custompintypes', this.custompintypes);
    set('projects', this.projects);
    set('buildings', this.buildings);
    set('damages', this.damages);
    set('custompins', this.custompins);
    set('notes', this.notes);
    set('sketches', this.sketches);
    set('ifcs', this.ifcs);
    set('xkts', this.xkts);
    // set('previews', this.previews);
    // set('photos', this.photos);
    set('componentgroups', this.componentgroups);
    set('damagetypes', this.damagetypes);
    set('examples', this.examples);
    set('damagetemplates', this.damagetemplates);
    set('client', this.client);
    set('last_sync', this.timestamp);

    return;
  }

  updateProgress() {
    this.sketchesLength = Object.keys(this.sketches).length;
    this.ifcLength = Object.keys(this.ifcs).length;
    this.xktLength = Object.keys(this.xkts).length;
    this.photosLength = Object.keys(this.photos).length;
    this.buildingPhotosLength = Object.keys(this.building_photos).length;
    this.recordingsLength = Object.keys(this.recordings).length;
    const sketchesTotal = this.sketchesLength;
    const sketchesDone = this.sketchFiles.length;
    this.sketchesProgress =
      sketchesTotal > 0
        ? Math.min(100, Math.round((sketchesDone / sketchesTotal) * 100))
        : 0;

    const photosTotal = this.photosLength + this.buildingPhotosLength;
    const photosDone = this.photoFiles.length + this.buildingPhotoFiles.length;
    this.photosProgress =
      photosTotal > 0
        ? Math.min(100, Math.round((photosDone / photosTotal) * 100))
        : 0;

    const recordingsTotal = this.recordingsLength;
    const recordingsDone = this.recordingFiles.length;
    this.recordingsProgress =
      recordingsTotal > 0
        ? Math.min(100, Math.round((recordingsDone / recordingsTotal) * 100))
        : 0;

    const ifcTotal = this.ifcLength;
    const ifcDone = this.ifcFiles.length;
    this.ifcProgress =
      ifcTotal > 0 ? Math.min(100, Math.round((ifcDone / ifcTotal) * 100)) : 0;

    const xktTotal = this.xktLength;
    const xktDone = this.xktFiles.length;
    this.xktProgress =
      xktTotal > 0 ? Math.min(100, Math.round((xktDone / xktTotal) * 100)) : 0;
  }

  /**
   * Rekursive NFC-Normalisierung aller String-Werte. Wird auf die
   * Sync-Down-Daten angewandt, damit decomposed (NFD) Umlaute zu
   * precomposed (NFC) werden. Hintergrund: Montserrat hat keine Glyphe für
   * das combining-Zeichen U+0308 — bei NFD-Text zeichnet iOS den Umlaut-
   * Strich per Font-Fallback leicht verschoben (Android/Web nicht). ASCII
   * bleibt unverändert; in-place für Performance.
   */
  private normalizeUnicodeDeep(value: any): any {
    if (typeof value === 'string') {
      return value.normalize('NFC');
    }
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        value[i] = this.normalizeUnicodeDeep(value[i]);
      }
      return value;
    }
    if (value && typeof value === 'object') {
      for (const k of Object.keys(value)) {
        value[k] = this.normalizeUnicodeDeep(value[k]);
      }
      return value;
    }
    return value;
  }

  async create(res) {
    // Write Global Objects as JSON to localstorage
    console.log('Lokaler Speicher wird erstellt');
    // Eingehende Sync-Daten auf NFC normalisieren (Umlaut-Darstellung iOS).
    res = this.normalizeUnicodeDeep(res);
    this.custompintypes = res.custompintypes;
    this.projects = res.projects;
    this.buildings = res.buildings;
    this.damages = res.damages;
    this.custompins = res.custompins;
    if (
      this.custompins == null ||
      typeof this.custompins == 'undefined' ||
      this.custompins == 'undefined' ||
      this.custompins == undefined
    ) {
      this.custompins = {};
    }

    if (Array.isArray(this.custompins) && this.custompins.length === 0) {
      console.log('ICH BIN EIN ARRAY!!!');
      // Wenn es ein leeres Array ist, in ein leeres Objekt umwandeln
      this.custompins = {};
    }
    console.log('custompins - in ss create', this.custompins);

    this.notes = res.notes;
    this.sketches = res.sketches;
    console.log('create IFCs', res.ifcs);
    this.ifcs = res.ifcs;
    console.log('create XKTS', this.xkts);
    // Since xkts pathes are inside the ifc objects, we set xkts to ifcs
    this.xkts = res.ifcs;

    /* this.updateProgress(); */

    this.componentgroups = res.componentgroups;
    this.damagetypes = res.damagetypes;
    this.examples = res.examples;
    this.damagetemplates = res.damagetemplates;

    var self = this;
    // Set Photos
    this.photos = [];
    this.building_photos = [];
    this.recordings = [];

    if (this.show_photos_offline) {
      $.each(this.damages, function (index, damage) {
        $.each(damage.photos, function (n, p) {
          let photo = {
            id: p.id,
            damage_id: damage.id,
            image_path: p.image_path,
          };
          self.photos.push(photo);
        });
        $.each(damage.audios, function (n, p) {
          if (p.is_own) {
            let audio = {
              id: p.id,
              damage_id: damage.id,
              file_path: p.url,
            };
            self.recordings.push(audio);
          }
        });
      });
      $.each(this.notes, function (index, note) {
        $.each(note.photos, function (n, p) {
          let photo = {
            id: p.id,
            damage_id: note.id,
            image_path: p.image_path,
          };
          self.photos.push(photo);
        });
        $.each(note.audios, function (n, p) {
          if (p.is_own) {
            let audio = {
              id: p.id,
              damage_id: note.id,
              file_path: p.url,
            };
            self.recordings.push(audio);
          }
        });
      });
      $.each(this.custompins, function (index, pin) {
        $.each(pin.photos, function (n, p) {
          let photo = {
            id: p.id,
            damage_id: pin.id,
            image_path: p.image_path,
          };
          self.photos.push(photo);
        });
        $.each(pin.audios, function (n, p) {
          if (p.is_own) {
            let audio = {
              id: p.id,
              damage_id: pin.id,
              file_path: p.url,
            };
            self.recordings.push(audio);
          }
        });
      });
      $.each(this.buildings, function (index, building) {
        $.each(building.pictures, function (n, p) {
          let photo = {
            id: p.id,
            building_id: building.id,
            image_path: p.url_big,
          };
          self.building_photos.push(photo);
        });
      });
    }
    this.updateProgress();
    console.log('Building_photos: ', this.building_photos);
    if (this.bu_del_photos_not_synced.length) {
      $.each(this.bu_del_photos_not_synced, function (index, building) {
        this.building[building.id].deleted_photos = building.deleted_photos;
      });
    }
    await set('custompintypes', res.custompintypes);
    await set('projects', res.projects);
    await set('buildings', res.buildings);
    await set('damages', res.damages);
    await set('custompins', res.custompins);
    await set('notes', res.notes);
    await set('sketches', res.sketches);
    await set('ifcs', res.ifcs);
    await set('xkts', res.ifcs);
    await set('componentgroups', res.componentgroups);
    await set('damagetypes', res.damagetypes);
    await set('examples', res.examples);
    await set('damagetemplates', res.damagetemplates);

    console.log('Delete alle Sketches - Done!');
    await this.deleteSketches();
    console.log('Delete alle Previews - Done!');
    await this.deletePreviews();
    console.log('Delete all Photos - Done!');
    await this.deletePhotos();
    console.log('Delete all Building Photos - Done!');
    await this.deleteBuildingPhotos();
    console.log('Delete all Recorings - Done!');
    await this.deleteRecordings();

    if (this.api.ifc_available) {
      // Deactivated for LIVE Version
      console.log('Lösche alle XKTs - Done!');
      await this.deleteXkts();

      console.log('Start downloading XKTs');
      await this.storeXkts();
    }

    console.log('Start downloading Sketches');
    await this.storeSketches();
    console.log('Start downloading Previews');
    await this.storePreviews();

    console.log('Start downloading Photos');
    if (this.show_photos_offline) {
      await this.storePhotos();
      await this.storeBuildingPhotos();
      await this.storeRecordings();
    }

    return;
  }

  public getPreviews() {
    this.previews = [];
    var self = this;
    $.each(this.buildings, function (index, building) {
      let preview_image = {
        id: building.id,
        project_id: 0,
        building_id: building.id,
        image_path: building.image_path,
      };
      self.previews.push(preview_image);
    });
    console.log(
      'Previews from buildings',
      JSON.parse(JSON.stringify(this.previews))
    );

    console.log(this.projects);
    $.each(this.projects, function (index, project) {
      let preview_image = {
        id: project.id,
        project_id: project.id,
        building_id: 0,
        image_path: project.image_path,
      };
      self.previews.push(preview_image);
    });
    set('previews', this.previews);

    return this.previews;
  }

  public async writeDownload(imageBlob, filename, id, self, type) {
    let directory = Directory.Data;
    let file: any;

    if (this.platform.is('ios')) {
      directory = Directory.Documents;
    }

    if (type != 'xkt' && type != 'rec' && type != 'xktmeta') {
      let base64 = await self.convertBlobToBase64(imageBlob);

      file = await Filesystem.writeFile({
        path: filename,
        data: String(base64),
        directory: directory,
      });
    } else {
      await write_blob({
        path: filename,
        directory,
        blob: imageBlob, // TODO: Ob das so gut ist bei recordings?
        recursive: true,
        on_fallback: (err) => console.warn('BlobWriter fallback', err), // optional
      });
    }

    const finalPhotoUri = await Filesystem.getUri({
      directory: directory,
      path: filename,
    });
    if (type == 'xkt' || type == 'rec' || type == 'xktmeta') {
      file = { uri: finalPhotoUri.uri };
    }

    let image_show_url = await Capacitor.convertFileSrc(finalPhotoUri.uri);
    console.log('Image Show URL in WriteDownload ', image_show_url);

    // Free refernces and memory
    try {
      imageBlob = null as any;
    } catch {}

    let shortcode = type + '-';

    if (type == 'sk') {
      //TODO: für building pictures auch? -> Ja.
      console.log('Progress Sketch Counter Before: ', this.sketch_counter);
      this.sketch_counter++;
      console.log('Progress Sketch Counter After: ', this.sketch_counter);

      if (!this.sketchFiles) {
        this.sketchFiles = [];
      }

      this.sketchFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });
      this.updateProgress();

      await set(self.SKETCHES_STORAGE, self.sketchFiles);

      var sketch_index = this.sketchFiles.findIndex(function (sketch) {
        return sketch.id == id;
      });
      this.sketchFiles[sketch_index].local_url = image_show_url;
    }

    if (type == 'ifc') {
      this.ifc_counter++;

      if (!this.ifcFiles) {
        this.ifcFiles = [];
      }

      this.ifcFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      this.updateProgress();
      await set(self.IFCFILES_STORAGE, self.ifcFiles);

      var ifc_index = this.ifcFiles.findIndex(function (ifc) {
        return ifc.id == id;
      });

      this.ifcFiles[ifc_index].local_url = image_show_url;
    }

    if (type == 'xkt') {
      this.xkt_counter++;

      if (!this.xktFiles) {
        this.xktFiles = [];
      }

      this.xktFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      this.updateProgress();
      await set(self.XKTFILES_STORAGE, this.xktFiles);

      var xkt_index = this.xktFiles.findIndex(function (xkt) {
        return xkt.id == id;
      });

      this.xktFiles[xkt_index].local_url = image_show_url;
    }

    if (type == 'pv') {
      this.preview_counter++;
      console.log(
        this.preview_counter +
          ' von ' +
          Object.keys(this.previews).length +
          ' Vorschaubilder wurde heruntergeladen'
      );

      if (!this.previewFiles) {
        this.previewFiles = [];
      }

      this.previewFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      await set(self.PREVIEWS_STORAGE, self.previewFiles);

      let project = this.projects[id];

      if (project) {
        console.log('Found project - set url ' + image_show_url);
        this.projects[id].local_url = image_show_url;
      }
    }

    if (type == 'ph') {
      this.photo_counter++;
      console.log(
        this.photo_counter +
          ' von ' +
          Object.keys(this.photos).length +
          ' Schadensbilder wurde heruntergeladen'
      );

      if (!this.photoFiles) {
        this.photoFiles = [];
      }
      this.photoFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      await set(self.PHOTOS_STORAGE, self.photoFiles);

      var photo_index = this.photoFiles.findIndex(function (photo) {
        return photo.id == id;
      });
      console.log('Index', photo_index);
      console.log('Set URL: ' + image_show_url + 'for ph ' + id);
      this.photoFiles[photo_index].local_url = image_show_url;
    }

    if (type == 'bu_ph') {
      this.buildings_photo_counter++;
      console.log(
        this.buildings_photo_counter +
          ' von ' +
          Object.keys(this.building_photos).length +
          ' Gebäudebildern wurde heruntergeladen'
      );

      if (!this.buildingPhotoFiles) {
        this.buildingPhotoFiles = [];
      }
      this.buildingPhotoFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      await set(self.BUILDINGS_PHOTOS_STORAGE, self.buildingPhotoFiles);

      var photo_index = this.buildingPhotoFiles.findIndex(function (photo) {
        return photo.id == id;
      });
      console.log('Index', photo_index);
      console.log('Set URL: ' + image_show_url + 'for bu_ph ' + id);
      this.buildingPhotoFiles[photo_index].local_url = image_show_url;
    }

    if (type == 'rec') {
      //this.ifc_counter++;
      this.recordings_counter++;
      console.log(
        this.recordings_counter +
          ' von ' +
          Object.keys(this.building_photos).length +
          ' Sprachaufnahmen wurde heruntergeladen'
      );

      if (!this.recordingFiles) {
        this.recordingFiles = [];
      }

      this.recordingFiles.unshift({
        filepath: file.uri,
        webviewPath: image_show_url,
        id: id,
      });

      this.updateProgress();
      await set(self.RECORDINGS_STORAGE, self.recordingFiles);

      var rec_index = this.recordingFiles.findIndex(function (rec) {
        return rec.id == id;
      });

      this.recordingFiles[rec_index].local_url = image_show_url;
    }

    return image_show_url;
  }

  public async singleDownload(element, type) {
    var id = element.id,
      filename,
      full_path;
    if (type != 'rec') {
      filename = element.image_path.replace(/^.*[\\\/]/, '');
      full_path = element.image_path;
    }

    var extension = 'jpg',
      self = this,
      shortcode = type + '-';

    if (type == 'xkt') {
      filename = element.xkt_path.replace(/^.*[\\\/]/, '');
      full_path = this.api.root + element.xkt_path;
      console.log('!!! Download XKT from ' + full_path + ' !!!');
      extension = 'xkt';
      console.log('Filename singleDownload XKT', filename + '/' + extension);
      console.log('singleDownload XKT', full_path);
    }

    // TODO: Recordings
    if (type == 'rec') {
      filename = element.file_path.replace(/^.*[\\\/]/, '');
      full_path = element.file_path;
      console.log('!!! Download Recording from ' + full_path + ' !!!');

      extension = 'aac';
    }

    // check if file is already there ? ...
    self.http
      .get(full_path, { responseType: 'blob' })
      .subscribe((imageBlob: Blob) => {
        self.writeDownload(imageBlob, filename, id, self, type);
        // Falls XKT: versuche passende JSON-Metadaten herunterzuladen
        if (type === 'xkt') {
          const jsonUrl = full_path.replace(/\.xkt$/i, '.json');
          const jsonName = filename.replace(/\.xkt$/i, '.json');
          self.http.get(jsonUrl, { responseType: 'blob' }).subscribe(
            (jsonBlob: Blob) => {
              console.log('!!! Download XKT meta from ' + jsonUrl + ' !!!');
              self.writeDownload(jsonBlob, jsonName, id, self, 'xktmeta');
            },
            () => {
              console.log('Kein XKT-JSON gefunden unter', jsonUrl);
            }
          );
        }
      });
  }

  public async redownloadSketch(sketch) {
    console.log('ReDownload Sketch', sketch);
    var id = sketch.id,
      filename = sketch.image_path.replace(/^.*[\\\/]/, ''),
      extension = 'jpg',
      full_path = sketch.image_path,
      self = this;

    console.log('Full path', full_path);

    self.http
      .get(full_path, { responseType: 'blob' })
      .subscribe((imageBlob: Blob) => {
        console.log('Image got downloaded as Blob');
        self
          .writeDownload(imageBlob, filename, id, self, 'sk')
          .then((newPath) => {
            console.log('New Path in subscribe ' + newPath);
            return newPath;
          });
      });
  }

  public async deleteSketches() {
    var self = this;
    let sketchFiles = await get(this.SKETCHES_STORAGE);
    if (sketchFiles) {
      sketchFiles.forEach(function (sketch) {
        var path = sketch.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.sketchFiles.splice(0);
      console.log('Is this called before Deletion done?');
      remove(self.SKETCHES_STORAGE);
    }
  }

  public async deletePhotos() {
    var self = this;
    let photoFiles = await get(this.PHOTOS_STORAGE);
    if (photoFiles) {
      photoFiles.forEach(function (photo) {
        var path = photo.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.photoFiles.splice(0);
      remove(self.PHOTOS_STORAGE);
    }
  }

  public async deleteBuildingPhotos() {
    var self = this;
    let photoFiles = await get(this.BUILDINGS_PHOTOS_STORAGE);
    if (photoFiles) {
      photoFiles.forEach(function (photo) {
        var path = photo.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.buildingPhotoFiles.splice(0);
      remove(self.BUILDINGS_PHOTOS_STORAGE);
    }
  }

  /* --------------------------------------------------------------------
     Modellbilder für die Prüfberichte (Level-2, Block 2a).

     Ein Snapshot aus dem 3D-Viewer darf offline nicht verlorengehen,
     deshalb dieselbe Bauart wie bei den Fotos: das PNG liegt als Datei
     im App-Ordner, in den Preferences steht nur der Warteschlangen-
     Eintrag. Hochgeladen wird später über den ModelViewService, siehe
     services/model-view.service.ts.

     Schlüssel eines Eintrags ist (Schaden, Modell, marker_index) — für
     dieselbe Markierung gibt es genau ein Bild. Ein erneutes Speichern
     der Markierungen ersetzt den Eintrag also, statt die Warteschlange
     mit veralteten Ständen aufzublähen. Der Server verhält sich beim
     Empfang genauso.
     -------------------------------------------------------------------- */

  /**
   * Löscht eine Modellbild-Datei. Bewusst nicht über deleteFile(): das
   * arbeitet fest auf Directory.Data, während die Bilder unter iOS in
   * Directory.Documents liegen (this.baseDir).
   */
  private async deleteModelViewFile(filename: string) {
    return await Filesystem.deleteFile({
      path: filename,
      directory: this.baseDir,
    });
  }

  /** Vergleichsschlüssel: Token schlägt ID, weil er den Sync überlebt. */
  private modelViewKey(entry: {
    damage_id: any;
    damage_token?: string | null;
    ifcfile_id: any;
    marker_index: number;
  }): string {
    const damage = entry.damage_token
      ? 't:' + entry.damage_token
      : 'i:' + entry.damage_id;
    return damage + '|' + entry.ifcfile_id + '|' + entry.marker_index;
  }

  /**
   * Schreibt das PNG in den App-Ordner und legt den Eintrag in die
   * Warteschlange. Ein vorhandener Eintrag mit demselben Schlüssel wird
   * samt Datei ersetzt.
   *
   * @param meta  Zuordnung und Aufnahmedaten (ohne Datei)
   * @param image PNG als data-URI oder blankes Base64 (aus viewer.getSnapshot())
   */
  public async queueModelView(
    meta: {
      damage_id: any;
      damage_token?: string | null;
      ifcfile_id: any;
      marker_index: number;
      camera?: any;
      marker_position?: number[] | null;
      source?: string;
    },
    image: string
  ): Promise<ModelViewQueueEntry | null> {
    if (!image) {
      return null;
    }

    // Filesystem.writeFile erwartet blankes Base64 — der data:-Präfix aus
    // getSnapshot() muss weg, sonst landet er mit in der Datei.
    const comma = image.indexOf(',');
    const raw = image.startsWith('data:') && comma > -1
      ? image.substring(comma + 1)
      : image;

    const filename =
      'modelview_' + new Date().getTime() + '_' + this.generate_token(6) + '.png';

    try {
      await Filesystem.writeFile({
        path: filename,
        data: raw,
        directory: this.baseDir,
      });
    } catch (e) {
      console.error('queueModelView: Datei konnte nicht abgelegt werden', e);
      this.presentToast('Das Modellbild konnte nicht gespeichert werden.');
      return null;
    }

    if (!Array.isArray(this.modelViewFiles)) {
      this.modelViewFiles = [];
    }

    const entry: ModelViewQueueEntry = {
      damage_id: meta.damage_id,
      damage_token: meta.damage_token || null,
      ifcfile_id: meta.ifcfile_id,
      marker_index: meta.marker_index,
      filename: filename,
      camera: meta.camera || null,
      marker_position: meta.marker_position || null,
      source: meta.source || 'capture',
      status: 0,
      created_at: new Date().toISOString(),
    };

    const key = this.modelViewKey(entry);
    const existing = this.modelViewFiles.findIndex(
      (e) => this.modelViewKey(e) === key
    );

    if (existing > -1) {
      const [old] = this.modelViewFiles.splice(existing, 1);
      this.deleteModelViewFile(old.filename).catch(() => {
        // Eine nicht löschbare Altdatei ist kein Grund, die Aufnahme zu verwerfen.
      });
    }

    this.modelViewFiles.push(entry);
    await this.updateModelViewsCache();

    return entry;
  }

  public async updateModelViewsCache() {
    await set(this.MODELVIEWS_STORAGE, this.modelViewFiles);
  }

  /** Eintrag samt Datei aus der Warteschlange nehmen (nach erfolgreichem Upload). */
  public async removeModelView(entry: ModelViewQueueEntry) {
    const key = this.modelViewKey(entry);
    const index = this.modelViewFiles.findIndex(
      (e) => this.modelViewKey(e) === key
    );

    if (index > -1) {
      this.modelViewFiles.splice(index, 1);
      await this.updateModelViewsCache();
    }

    try {
      await this.deleteModelViewFile(entry.filename);
    } catch (e) {
      console.log('removeModelView: Datei bereits weg oder nicht löschbar', e);
    }
  }

  /** Anzahl der noch nicht hochgeladenen Modellbilder. */
  public countPendingModelViews(): number {
    if (!Array.isArray(this.modelViewFiles)) {
      return 0;
    }
    return this.modelViewFiles.filter((e) => e.status == 0).length;
  }

  public async deleteModelViews() {
    var self = this;
    let modelViewFiles = await get(this.MODELVIEWS_STORAGE);
    if (modelViewFiles) {
      modelViewFiles.forEach(function (view) {
        self.deleteModelViewFile(view.filename).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.modelViewFiles.splice(0);
      remove(self.MODELVIEWS_STORAGE);
    }
  }

  public async deleteRecordings() {
    var self = this;
    let recFiles = await get(this.RECORDINGS_STORAGE);
    if (recFiles) {
      recFiles.forEach(function (rec) {
        var path = rec.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.recordingFiles.splice(0);
      remove(self.RECORDINGS_STORAGE);
    }
  }

  public async deleteIfcs() {
    var self = this;
    let ifcFiles = await get(this.IFCFILES_STORAGE);
    if (ifcFiles) {
      ifcFiles.forEach(function (ifc) {
        var path = ifc.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.ifcFiles.splice(0);
      console.log('Is this called before Deletion done?');
      remove(self.IFCFILES_STORAGE);
    }
    this.updateProgress();
  }

  public async deleteXkts() {
    var self = this;
    let xktFiles = await get(this.XKTFILES_STORAGE);
    if (xktFiles) {
      xktFiles.forEach(function (xkt) {
        var path = xkt.filepath;
        self.deleteFile(path).then(function (e) {
          console.log('Deletion done?', e);
        });
      });
      self.xktFiles.splice(0);
      console.log('Is this called before Deletion done?');
      remove(self.XKTFILES_STORAGE);
    }
    this.updateProgress();
  }

  public async deletePreviews() {
    var self = this;
    let previewFiles = await get(this.PREVIEWS_STORAGE);

    if (previewFiles) {
      console.log('Delete Preview Files', previewFiles);
      previewFiles.forEach(function (preview) {
        var path = preview.filepath;
        console.log('Preview will deleted!');
        self.deleteFile(path).then(function (e) {
          console.log('Preview has been deleted ', e);
        });
      });
      self.previewFiles.splice(0);
      remove(self.PREVIEWS_STORAGE);
    }
  }

  public async deleteFile(path) {
    return await Filesystem.deleteFile({
      path: path,
      directory: Directory.Data,
    });
  }

  /**
   * Löscht ALLE lokal gespeicherten Dateien (Fotos, XKT/IFC-Modelle, Audio,
   * Skizzen) im App-Basisordner. Wird beim Umgebungswechsel aufgerufen, damit
   * der App-Ordner nicht mit Daten der vorherigen Umgebung volläuft.
   */
  public async wipeLocalFiles(): Promise<void> {
    try {
      const result = await Filesystem.readdir({
        path: '',
        directory: this.baseDir,
      });
      for (const entry of result.files) {
        try {
          if ((entry as any).type === 'directory') {
            await Filesystem.rmdir({
              path: entry.name,
              directory: this.baseDir,
              recursive: true,
            });
          } else {
            await Filesystem.deleteFile({
              path: entry.name,
              directory: this.baseDir,
            });
          }
        } catch (e) {
          console.warn('wipeLocalFiles: Eintrag nicht löschbar', entry.name, e);
        }
      }
    } catch (e) {
      console.warn('wipeLocalFiles: readdir fehlgeschlagen', e);
    }
  }

  public storeSketches() {
    // Write Global Objects as JSON to localstorage
    // console.log("Skizzen werden heruntergeladen und lokal gespeichert.");
    // console.log("Sketches on Store Sketches", this.sketches);
    for (var key in this.sketches) {
      // skip loop if the property is from prototype
      if (!this.sketches.hasOwnProperty(key)) continue;

      var sketch = this.sketches[key];
      // console.log("Sketch", sketch);
      this.singleDownload(sketch, 'sk');
    }
  }

  public storeXkts() {
    console.log('storeXkts', this.xkts);
    for (var key in this.xkts) {
      // skip loop if the property is from prototype
      if (!this.xkts.hasOwnProperty(key)) continue;

      var xkt = this.xkts[key];
      // console.log("Sketch", sketch);
      this.singleDownload(xkt, 'xkt');
    }
  }

  public storePreviews() {
    let previews = this.getPreviews();
    // Write Global Objects as JSON to localstorage
    console.log('Vorschaubilder werden heruntergeladen und lokal gespeichert.');
    console.log('Previews on Store Previews', previews);
    // Find preview images
    for (var key in previews) {
      // skip loop if the property is from prototype
      if (!previews.hasOwnProperty(key)) continue;

      var preview = previews[key];
      console.log('Store Preview: ', preview);
      this.singleDownload(preview, 'pv');
    }
  }

  public storePhotos() {
    // Write Global Objects as JSON to localstorage
    console.log('Photos werden heruntergeladen und lokal gespeichert.');
    console.log(this.photos);
    // Find photos for offline storage
    for (var key in this.photos) {
      // skip loop if the property is from prototype
      if (!this.photos.hasOwnProperty(key)) continue; // Property-Key -> Photo is null!

      var photo = this.photos[key];
      console.log('Photos: ', photo);
      this.singleDownload(photo, 'ph');
    }
  }

  public storeBuildingPhotos() {
    // Write Global Objects as JSON to localstorage
    console.log(
      'Building-Photos werden heruntergeladen und lokal gespeichert.'
    );
    console.log(this.building_photos);
    // Find photos for offline storage
    for (var key in this.building_photos) {
      // skip loop if the property is from prototype
      if (!this.building_photos.hasOwnProperty(key)) continue; // Property-Key -> Photo is null!

      var photo = this.building_photos[key];
      console.log('Building-Photos: ', photo);
      this.singleDownload(photo, 'bu_ph');
    }
  }

  public storeRecordings() {
    // Write Global Objects as JSON to localstorage
    console.log(
      'Sprachaufnahmen werden heruntergeladen und lokal gespeichert.'
    );
    console.log(this.recordings);
    // Find photos for offline storage
    for (var key in this.recordings) {
      // skip loop if the property is from prototype
      if (!this.recordings.hasOwnProperty(key)) continue;

      var recording = this.recordings[key];
      console.log('Recordings: ', recording);
      this.singleDownload(recording, 'rec');
    }
  }

  public async storePreferences() {
    console.log('Preferences Status: ', this.show_photos_offline);

    let preferences = {
      show_photos_offline: this.show_photos_offline,
    };

    await set(this.PREFERENCES_STORAGE, preferences);
  }

  public padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  syncDown(): RxObservable<any> {
    return this.api.getProjects().pipe(
      tap((res) => {
        console.log('!!NEW DATA COMING IN!!', res);
        this.create(res);

        const d = new Date();
        this.timestamp =
          'Letzte Synchronisierung: ' +
          this.padZero(d.getDate()) +
          '.' +
          this.padZero(d.getMonth() + 1) +
          '.' +
          d.getFullYear() +
          ' um ' +
          this.padZero(d.getHours()) +
          ':' +
          this.padZero(d.getMinutes()) +
          ':' +
          this.padZero(d.getSeconds()) +
          'Uhr';

        set('last_sync', this.timestamp);
      }),
      map((res) => res.projects),
      tap({ error: (err) => console.error(err) })
    );
  }

  async showLoader() {
    this.loader = await this.loadingController.create();
    await this.loader.present();
  }

  hideLoader() {
    this.loader.dismiss();
  }

  //Building-Sync:////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /*   type BuildingsMap = Record<string, any>;

type UploadDone = (() => void) | null | undefined; */

  /*  private collectFromBuildings<T>(
    buildings: any,
    buildItem: (id: string, building: any) => T | null
  ): T[] {
    if (!buildings) return [];

    const ids = Object.keys(buildings);
    if (ids.length === 0) return [];

    const out: T[] = [];
    for (const id of ids) {
      const item = buildItem(id, buildings[id]);
      if (item !== null) out.push(item);
    }
    return out;
  }

  private uploadQueue(
    queue: any[],
    push: (item: any) => Promise<any>,
    onSuccessClear: () => void,
    onFailStoreRemaining: (remaining: any[]) => void,
    onFailToast: () => void,
    callback?: any
  ): void {
    const done = () => callback?.();

    const runNext = (): void => {
      if (queue.length === 0) {
        onSuccessClear();
        done();
        return;
      }

      const item = queue[0];
      push(item)
        .then(() => {
          queue.shift(); // statt splice(0,1)
          runNext();
        })
        .catch((err) => {
          console.log('Upload failed:', err?.message ?? err);
          onFailToast();
          onFailStoreRemaining(queue);
          done();
        });
    };

    runNext();
  }

  getDeletedBuildingPhotos(): string[] {
    const deleted = this.collectFromBuildings(
      this.buildings,
      (id, building) => {
        if (!building?.deleted_photos) return null;

        return JSON.stringify({
          id,
          deleted_photos: building.deleted_photos,
        });
      }
    );

    console.log('Deleted Building Photos', deleted);
    return deleted;
  }

  getBuildingPhotoNotes(): string[] {
    const notesCollection = this.collectFromBuildings(
      this.buildings,
      (id, building) => {
        const pictures = building?.pictures ?? [];
        const notes = pictures.map((photo: any) => ({
          id: photo?.pivot?.id,
          note: photo?.pivot?.note,
        }));

        return JSON.stringify({
          id,
          data: notes,
        });
      }
    );

    console.log('BuildingPhotoNotes Collection', notesCollection);
    return notesCollection;
  }

  syncBuildingPhotoNotes(): RxObservable<void> {
    const payload = this.getBuildingPhotoNotes();

    return new RxObservable<void>((observer) => {
      const finished = () => {
        console.log('Upload Building Notes finished');
        observer.next();
        observer.complete();
      };

      try {
        this.uploadBuildingPhotoNotes(payload, finished);
      } catch (e) {
        observer.error(e);
      }
    });
  }

  syncBuildingDeletions(): RxObservable<void> {
    const payload = this.getDeletedBuildingPhotos();

    return new RxObservable<void>((observer) => {
      const finished = () => {
        console.log('Upload Photo Deletion finished');
        observer.next();
        observer.complete();
      };

      try {
        this.uploadBuildingPhotoDeletions(payload, finished);
      } catch (e) {
        observer.error(e);
      }
    });
  }

  uploadBuildingPhotoNotes(
    buildings_photo_notes: any[],
    callback: any = null
  ): void {
    if (
      !Array.isArray(buildings_photo_notes) ||
      buildings_photo_notes.length === 0
    ) {
      console.log('Upload Building Photo Notes finished!');
      this.bu_photo_notes_not_synced = [];
      callback?.();
      return;
    }

    console.log('BuildingPhotoNotes', buildings_photo_notes);

    this.uploadQueue(
      buildings_photo_notes,
      (item) => this.api.pushBuildingPhotoNotes(item),
      () => {
        console.log('Upload Building Photo Notes finished!');
        this.bu_photo_notes_not_synced = [];
      },
      (remaining) => {
        this.bu_photo_notes_not_synced = remaining;
      },
      () => {
        this.presentToast(
          'Die Notizen der Gebäudephotos konnten nicht übermittelt werden - Versuchen Sie es später erneut.'
        );
      },
      callback
    );
  }

  uploadBuildingPhotoDeletions(
    buildings_with_del_photos: any[],
    callback: any = null
  ): void {
    if (
      !Array.isArray(buildings_with_del_photos) ||
      buildings_with_del_photos.length === 0
    ) {
      console.log('Upload Building Photo Deletion Info finished!');
      this.bu_del_photos_not_synced = [];
      callback?.();
      return;
    }

    console.log('BuildingDel', buildings_with_del_photos);

    this.uploadQueue(
      buildings_with_del_photos,
      (item) => this.api.pushDeletedBuildingPhotos(item),
      () => {
        console.log('Upload Building Photo Deletion Info finished!');
        this.bu_del_photos_not_synced = [];
      },
      (remaining) => {
        this.bu_del_photos_not_synced = remaining;
      },
      () => {
        this.presentToast(
          'Die Gebäudephotos konnten nicht gelöscht werden - Versuchen Sie es später erneut.'
        );
      },
      callback
    );
  } */

  getDeletedBuildingPhotos() {
    let self = this;
    let deleted_photos = [];

    if (this.buildings) {
      if (Object.keys(this.buildings).length) {
        let building_ids = Object.keys(this.buildings);
        building_ids.map((id) => {
          if (self.buildings[id].deleted_photos) {
            deleted_photos.push(
              JSON.stringify({
                id: id,
                deleted_photos: self.buildings[id].deleted_photos,
              })
            );
          }
        });
      }
    }

    console.log('Deleted Building Photos', deleted_photos);
    return deleted_photos;
  }

  getBuildingPhotoNotes() {
    let self = this;
    let photo_notes = [];

    if (this.buildings) {
      if (Object.keys(this.buildings).length) {
        let building_ids = Object.keys(this.buildings);
        building_ids.map((id) => {
          let notes = [];

          self.buildings[id].pictures.map(function (photo) {
            notes.push({ id: photo.pivot.id, note: photo.pivot.note });
          });

          photo_notes.push(
            JSON.stringify({
              id: id,
              data: notes,
            })
          );
          console.log('BuildingPhotoNotes Notes', notes);
        });
      }
    }

    console.log('BuildingPhotoNotes Collection', photo_notes);
    return photo_notes;
  }

  getDataFromBuilding() {
    let self = this;
    let photo_notes = [];

    if (this.buildings) {
      if (Object.keys(this.buildings).length) {
        let building_ids = Object.keys(this.buildings);
        building_ids.map((id) => {
          let notes = [];

          self.buildings[id].pictures.map(function (photo) {
            notes.push({ id: photo.pivot.id, note: photo.pivot.note });
          });

          photo_notes.push(
            JSON.stringify({
              id: id,
              data: notes,
            })
          );
          console.log('BuildingPhotoNotes Notes', notes);
        });
      }
    }

    console.log('BuildingPhotoNotes Collection', photo_notes);
    return photo_notes;
  }

  isNotEmptyArr(buildings_arr: any) {
    return buildings_arr.length > 0;
  }

  ////////////////

  syncBuildingPhotoNotes(): RxObservable<void> {
    let buildings_photo_notes = this.getBuildingPhotoNotes();

    return new RxObservable<void>((observer) => {
      const finished_upload = () => {
        console.log('Upload Building Notes finished');
        observer.next();
        observer.complete();
      };

      try {
        // Upload startet JETZT
        this.uploadBuildingPhotoNotes(buildings_photo_notes, finished_upload);
      } catch (e) {
        observer.error(e);
      }
    });
  }

  syncBuildingDeletions(): RxObservable<void> {
    let buildings_del_photos = this.getDeletedBuildingPhotos();

    return new RxObservable<void>((observer) => {
      const finished_upload = () => {
        console.log('Upload Photo Deletion finished');
        observer.next();
        observer.complete();
      };

      try {
        // Upload startet JETZT
        this.uploadBuildingPhotoDeletions(
          buildings_del_photos,
          finished_upload
        );
      } catch (e) {
        observer.error(e);
      }
    });
  }

  ////////////////

  uploadBuildingPhotoNotes(buildings_photo_notes: any, callback = null) {
    let self = this;
    if (this.isNotEmptyArr(buildings_photo_notes)) {
      let building = buildings_photo_notes[0];
      console.log('BuildingPhotoNotes', buildings_photo_notes);
      this.api
        .pushBuildingPhotoNotes(building)
        .then(() => {
          buildings_photo_notes.splice(0, 1);
          self.uploadBuildingPhotoNotes(buildings_photo_notes, callback);
        })
        .catch((err) => {
          console.log(
            'Upload building photo notes failed:',
            err?.message ?? err
          );
          self.presentToast(
            'Die Notizen der Gebäudephotos konnten nicht übermittelt werden - Versuchen Sie es später erneut.'
          );

          self.bu_photo_notes_not_synced = buildings_photo_notes; // Muss nach Sync wieder gesetzt werden!;
          callback();
        });
    } else {
      console.log('Upload Building Photo Notes finished!');
      self.bu_photo_notes_not_synced = [];
      callback();
    }
  }

  uploadBuildingPhotoDeletions(
    buildings_with_del_photos: any,
    callback = null
  ) {
    let self = this;
    if (this.isNotEmptyArr(buildings_with_del_photos)) {
      //let building = this.buildings[buildings_with_del_photos[0].id];
      let building = buildings_with_del_photos[0];
      console.log('BuildingDel', buildings_with_del_photos);
      this.api
        .pushDeletedBuildingPhotos(building)
        .then(() => {
          buildings_with_del_photos.splice(0, 1);
          self.uploadBuildingPhotoDeletions(
            buildings_with_del_photos,
            callback
          );
        })
        .catch((err) => {
          console.log('Delete building photos failed:', err?.message ?? err);
          self.presentToast(
            'Die Gebäudephotos konnten nicht gelöscht werden - Versuchen Sie es später erneut.'
          );

          self.bu_del_photos_not_synced = buildings_with_del_photos; // Muss nach Sync wieder gesetzt werden!;
          callback();
        });
    } else {
      console.log('Upload Building Photo Deletion Info finished!');
      self.bu_del_photos_not_synced = [];
      callback();
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  syncUp(): RxObservable<any> {
    return this.api
      .pushDamages(this.damages, this.notes, this.custompins)
      .pipe(tap({ error: (err) => console.error(err) }));
  }

  async reloadProjects() {
    console.log('Projects Page : Synchronisierung startet!');
    /*     var ss = this;
    ss.syncUp(); */
    await this.showLoader();
    const deleteBuildingPhotos = await firstValueFrom(
      this.syncBuildingDeletions()
    );
    const syncUp = await firstValueFrom(this.syncUp());
    const syncDown = await firstValueFrom(this.syncDown());
    this.presentToast(
      'Projekte wurden erfolgreich synchronisiert. Fehlende Skizzen und Vorschaubilder werden im Hintergrund heruntergeladen.'
    );
    this.save();
    this.hideLoader();
  }

  // Helpers
  convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = this.getFileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      return reader.readAsDataURL(blob);
    });

  getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)[
      '__zone_symbol__originalInstance'
    ];
    return zoneOriginalInstance || fileReader;
  }

  async presentToast(message) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
    });
    toast.present();
  }

  isEqual(value, other) {
    var self = this;
    var type = Object.prototype.toString.call(value);
    if (type !== Object.prototype.toString.call(other)) return false;

    if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

    var valueLen =
      type === '[object Array]' ? value.length : Object.keys(value).length;
    var otherLen =
      type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    var compare = function (item1, item2) {
      var itemType = Object.prototype.toString.call(item1);
      if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
        if (!self.isEqual(item1, item2)) return false;
      } else {
        if (itemType !== Object.prototype.toString.call(item2)) return false;
        if (itemType === '[object Function]') {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 !== item2) return false;
        }
      }
    };

    if (type === '[object Array]') {
      for (var i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) return false;
      }
    } else {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false;
        }
      }
    }

    return true;
  }

  // Helper
  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  objectKeys(obj: object): string[] {
    return Object.keys(obj);
  }

  generate_token(length) {
    //edit the token allowed characters
    var a =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split(
        ''
      );
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }
}

// Interfaces
interface Sketch {
  filepath: string;
  webviewPath: string;
  id: number;
  base64?: string;
  local_url?: string;
}

interface Preview {
  filepath: string;
  webviewPath: string;
  id: number;
  base64?: string;
  local_url?: string;
}

interface Photo {
  filepath: string;
  webviewPath: string;
  id: number;
  base64?: string;
  local_url?: string;
}

/**
 * Ein Modellbild in der Offline-Warteschlange (Level-2-Prüfberichte, Block 2a).
 *
 * `damage_id` ist bei einem offline neu angelegten Schaden nur eine lokale
 * Zufallszahl — dort trägt `damage_token` die Zuordnung, die den Sync
 * überlebt. `status`: 0 = wartet, -1 = übersprungen (Datei nicht lesbar).
 */
export interface ModelViewQueueEntry {
  damage_id: any;
  damage_token: string | null;
  ifcfile_id: any;
  marker_index: number;
  filename: string;
  camera: any;
  marker_position: number[] | null;
  source: string;
  status: number;
  created_at: string;
}
